import React, {useCallback, useEffect, useRef, useState} from 'react';
import Layout from 'antd/lib/layout';
import Menu from 'antd/lib/menu';
import {useDispatch, useSelector} from 'react-redux';
import {Link, useLocation} from 'react-router-dom';

import {ACTIVE_GIFTS_PAGE, REALIZED_GIFTS_PAGE, REQUISITES_GIFTS_PAGE} from 'router/pages';

import * as appActions from 'app/actions';
import {isUserLoggedIn} from 'app/reducers/commonData/selectors';
import LoaderSpinner from 'components/LoaderSpinner';
import {useUserRole} from 'hooks/useUserRole';

import Logo from 'images/icon/logo.svg';

import styles from './header.module.scss';

const pagesKeys: Record<string, string> = {
    [REQUISITES_GIFTS_PAGE]: '1',
    [ACTIVE_GIFTS_PAGE]: '2',
    [REALIZED_GIFTS_PAGE]: '3',
};

const renderNavigationItems = (isGuest: boolean, onNavigate?: () => void): React.ReactNode[] => {
    if (isGuest) {
        return [
            <Menu.Item key="1">
                <Link to={REQUISITES_GIFTS_PAGE} onClick={onNavigate}>
                    Реквізити
                </Link>
            </Menu.Item>,

            <Menu.Item key="2">
                <Link to={ACTIVE_GIFTS_PAGE} onClick={onNavigate}>
                    Бажання Дітей
                </Link>
            </Menu.Item>,

            <Menu.Item key="3">
                <Link to={REALIZED_GIFTS_PAGE} onClick={onNavigate}>
                    Втілені Мрії
                </Link>
            </Menu.Item>,
        ];
    }
    return [
        <Menu.Item key="1">
            <Link to={REQUISITES_GIFTS_PAGE} onClick={onNavigate}>
                Реквізити
            </Link>
        </Menu.Item>,

        <Menu.Item key="2">
            <Link to={ACTIVE_GIFTS_PAGE} onClick={onNavigate}>
                Бажання Дітей
            </Link>
        </Menu.Item>,
    ];
};

const facebookLink = (
    // eslint-disable-next-line react/jsx-no-target-blank
    <a className="social-link" href="https://www.facebook.com/groups/197762237039265" target="_blank">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.96 3C7.011 3 3 7.011 3 11.96C3 16.909 7.011 20.92 11.96 20.92C16.909 20.92 20.92 16.909 20.92 11.96C20.92 7.011 16.909 3 11.96 3ZM17.553 17.5495C16.825 18.2775 15.9815 18.848 15.04 19.2435C14.067 19.6565 13.031 19.863 11.96 19.863C10.8925 19.863 9.8565 19.653 8.88 19.2435C7.9385 18.8445 7.0915 18.274 6.367 17.5495C5.639 16.8215 5.0685 15.978 4.673 15.0365C4.26 14.0635 4.05 13.0275 4.05 11.96C4.05 10.8925 4.26 9.8565 4.6695 8.88C5.0685 7.9385 5.639 7.0915 6.3635 6.367C7.095 5.639 7.9385 5.0685 8.88 4.6695C9.8565 4.26 10.8925 4.05 11.96 4.05C13.0275 4.05 14.0635 4.26 15.04 4.6695C15.9815 5.0685 16.8285 5.639 17.553 6.3635C18.281 7.0915 18.8515 7.935 19.247 8.8765C19.66 9.8495 19.8665 10.8855 19.8665 11.9565C19.8665 13.024 19.6565 14.06 19.247 15.0365C18.848 15.978 18.2775 16.825 17.553 17.5495Z"
                fill="#124D91"
            />
            <path
                d="M13.143 8.90407C13.5035 8.90407 13.8885 9.01607 13.8885 9.01607L14.1195 7.64407C14.1195 7.64407 13.6295 7.47607 12.4605 7.47607C11.743 7.47607 11.3265 7.74907 11.022 8.15157C10.735 8.53307 10.7245 9.14557 10.7245 9.54107V10.4406H9.797V11.7811H10.7245V16.4361H12.4605V11.7811H13.836L13.9375 10.4406H12.4605V9.39407C12.4605 9.03357 12.7825 8.90407 13.143 8.90407Z"
                fill="#124D91"
            />
        </svg>
    </a>
);

const instaLink = (
    // eslint-disable-next-line react/jsx-no-target-blank
    <a className="social-link" href="https://instagram.com/dobrota_ta_dovira?igshid=140j7zzmzvo77" target="_blank">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_5772_6688)">
                <path
                    d="M11.96 3C7.011 3 3 7.011 3 11.96C3 16.909 7.011 20.92 11.96 20.92C16.909 20.92 20.92 16.909 20.92 11.96C20.92 7.011 16.909 3 11.96 3ZM17.553 17.5495C16.825 18.2775 15.9815 18.848 15.04 19.2435C14.067 19.6565 13.031 19.863 11.96 19.863C10.8925 19.863 9.8565 19.653 8.88 19.2435C7.9385 18.8445 7.0915 18.274 6.367 17.5495C5.639 16.8215 5.0685 15.978 4.673 15.0365C4.26 14.0635 4.05 13.0275 4.05 11.96C4.05 10.8925 4.26 9.8565 4.6695 8.88C5.0685 7.9385 5.639 7.0915 6.3635 6.367C7.095 5.639 7.9385 5.0685 8.88 4.6695C9.8565 4.26 10.8925 4.05 11.96 4.05C13.0275 4.05 14.0635 4.26 15.04 4.6695C15.9815 5.0685 16.8285 5.639 17.553 6.3635C18.281 7.0915 18.8515 7.935 19.247 8.8765C19.66 9.8495 19.8665 10.8855 19.8665 11.9565C19.8665 13.024 19.6565 14.06 19.247 15.0365C18.848 15.978 18.2775 16.825 17.553 17.5495Z"
                    fill="#124D91"
                />
                <path
                    d="M14.711 7.47998H9.21599C8.26049 7.47998 7.48349 8.25698 7.48349 9.21248V11.043V14.711C7.48349 15.6665 8.26049 16.4435 9.21599 16.4435H14.711C15.6665 16.4435 16.4435 15.6665 16.4435 14.711V11.0395V9.20898C16.44 8.25698 15.663 7.47998 14.711 7.47998ZM15.208 8.51248H15.4075V8.70848V10.0315L13.892 10.035L13.8885 8.51598L15.208 8.51248ZM10.6825 11.0395C10.9695 10.644 11.435 10.3815 11.96 10.3815C12.485 10.3815 12.9505 10.6405 13.2375 11.0395C13.4265 11.2985 13.535 11.617 13.535 11.96C13.535 12.828 12.828 13.5385 11.9565 13.5385C11.085 13.5385 10.385 12.828 10.385 11.96C10.385 11.617 10.497 11.2985 10.6825 11.0395ZM15.5685 14.7075C15.5685 15.18 15.1835 15.565 14.711 15.565H9.21599C8.74349 15.565 8.35849 15.18 8.35849 14.7075V11.0395H9.69549C9.57999 11.323 9.51349 11.6345 9.51349 11.96C9.51349 13.311 10.6125 14.41 11.9635 14.41C13.3145 14.41 14.4135 13.311 14.4135 11.96C14.4135 11.6345 14.347 11.323 14.2315 11.0395H15.5685V14.7075Z"
                    fill="#124D91"
                />
            </g>
            <defs>
                <clipPath id="clip0_5772_6688">
                    <rect width="17.92" height="17.92" fill="white" transform="translate(3 3)" />
                </clipPath>
            </defs>
        </svg>
    </a>
);

const Header = (): JSX.Element => {
    const {isGuest} = useUserRole();
    const {pathname} = useLocation();

    const dispatch = useDispatch();
    const isLoggedInUser = useSelector(isUserLoggedIn);

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const mobileMenuRef = useRef<HTMLDivElement>(null);

    const currentPageKey = pagesKeys[pathname];
    const selectedKeys = currentPageKey ? [currentPageKey] : [];

    const closeMenu = useCallback(() => {
        setIsMenuOpen(false);
    }, []);

    const toggleMenu = useCallback(() => {
        setIsMenuOpen(prev => !prev);
    }, []);

    const logOutHandler = useCallback(() => {
        closeMenu();
        dispatch(appActions.logOut());
    }, [dispatch, closeMenu]);

    useEffect(() => {
        closeMenu();
    }, [pathname, closeMenu]);

    useEffect(() => {
        if (!isMenuOpen) {
            return;
        }
        const handleOutsideClick = (event: MouseEvent): void => {
            if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target as Node)) {
                closeMenu();
            }
        };

        const handleKeyDown = (event: KeyboardEvent): void => {
            if (event.key === 'Escape') {
                closeMenu();
            }
        };

        document.addEventListener('mousedown', handleOutsideClick);
        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [isMenuOpen, closeMenu]);

    return (
        <>
            <LoaderSpinner />

            <Layout.Header className={styles.wrap}>
                <div className={styles.item}>
                    <div className={styles.logo}>
                        <Link to="/" onClick={closeMenu} aria-label="На головну">
                            <img src={Logo} alt='ОБФ "Доброта та Довіра"' />
                        </Link>
                    </div>

                    {/* Desktop navigation */}
                    <nav className={styles.desktopNavigation} aria-label="Основна навігація">
                        <Menu mode="horizontal" selectedKeys={selectedKeys}>
                            {renderNavigationItems(isGuest)}
                        </Menu>
                    </nav>

                    {/* Mobile navigation */}
                    <div className={styles.mobileNavigation} ref={mobileMenuRef}>
                        <button
                            type="button"
                            className={`${styles.menuButton} ${isMenuOpen ? styles.menuButtonOpen : ''}`}
                            onClick={toggleMenu}
                            aria-label={isMenuOpen ? 'Закрити меню' : 'Відкрити меню'}
                            aria-expanded={isMenuOpen}
                            aria-controls="mobile-navigation"
                        >
                            <span className={styles.burger} />
                        </button>
                        <nav
                            id="mobile-navigation"
                            className={`${styles.mobileDropdown} ${isMenuOpen ? styles.mobileDropdownOpen : ''}`}
                            aria-label="Мобільна навігація"
                            aria-hidden={!isMenuOpen}
                        >
                            {isMenuOpen && (
                                <Menu mode="vertical" selectedKeys={selectedKeys} onClick={closeMenu}>
                                    {renderNavigationItems(isGuest, closeMenu)}
                                </Menu>
                            )}
                        </nav>
                    </div>

                    {/* Contacts */}
                    <div className={styles.contacts}>
                        <a href="tel:+380972397270" className={styles.phone}>
                            <strong>+38 097 239 72 70</strong>
                        </a>

                        <div className={styles.socials}>
                            {facebookLink}
                            {instaLink}
                        </div>

                        {isLoggedInUser && (
                            <button type="button" className={styles.logout} onClick={logOutHandler}>
                                Logout
                            </button>
                        )}
                    </div>
                </div>
            </Layout.Header>
        </>
    );
};

export default Header;
